import Settings from './components/Settings'

export default Settings
